<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field :label="$t('detailContrat.renouvellement.contrat.reconductible')"
                custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.reconductible ? $t('general.oui')
            : $t('general.non') }}
          </span>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('detailContrat.renouvellement.contrat.tacite')"
                 custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.tacite ? $t('general.oui')
            : $t('general.non') }}
          </span>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('detailContrat.renouvellement.contrat.etatRenouvellement')"
                 custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ $t(getEtatRenouvellementLibelle(contrat.etatRenouvellement)) }}
          </span>
        </b-field>
      </div>
      <div class="column is-12" v-if="hasMotifNonRenouvellement">
        <b-field :label="$t('detailContrat.renouvellement.contrat.motifNonRenouvellement')"
                 custom-class="has-text-default is-italic has-text-weight-light mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ contrat.motifNonRenouvellement }}
          </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { LISTE_ETAT_RENOUVELLEMENT, ETAT_NONRENOUVELEE } from '@/configuration/devisConf';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasMotifNonRenouvellement() {
      return this.contrat.etatRenouvellement === ETAT_NONRENOUVELEE;
    },
  },
  methods: {
    getEtatRenouvellementLibelle(code) {
      const codeLibelle = LISTE_ETAT_RENOUVELLEMENT.find(etatRenouvellement => {
        return etatRenouvellement.code === code;
      });
      return codeLibelle?.libelle;
    },
  },
};
</script>
